module.exports = __webpack_public_path__ + "img/bg-effect-team.7394acc9.png";